import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';

import muiPropForwarding from 'styles/helpers/muiPropForwarding';
import { getSectionNavMediumColor } from 'styles/helpers/getThemeStyles';

const ButtonWrapper = styled(Box, {
  shouldForwardProp: muiPropForwarding('right', 'top')
})(({ theme, right = 0, top = 0 }) => ({
  position: 'absolute',
  right: theme.spacing(right),
  top: theme.spacing(top),
  zIndex: theme.zIndex.mobileStepper
}));

const StyledCloseIcon = styled(CloseIcon, {
  shouldForwardProp: muiPropForwarding('color')
})(({ theme, color }) => ({
  fill: color ?? getSectionNavMediumColor(theme)
}));

function CloseButton({ handleClick, autoFocus, ...rest }) {
  const { color, right, top } = rest;
  return (
    <Box position="relative">
      <ButtonWrapper right={right} top={top}>
        <IconButton
          autoFocus={autoFocus}
          aria-label="Close"
          onClick={handleClick}
          data-testid="close-button"
        >
          <StyledCloseIcon color={color} />
        </IconButton>
      </ButtonWrapper>
    </Box>
  );
}

CloseButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool
};

export default CloseButton;
